import type { TermsAndConditionsBrand } from '~/consts/termsAndConditions';

export const termsAndConditionsQueryKeys = {
  all: ['content', 'terms-and-conditions'] as const,
  lists: () => [...termsAndConditionsQueryKeys.all, 'list'] as const,
  list: (brand: TermsAndConditionsBrand) => [...termsAndConditionsQueryKeys.lists(), brand] as const,
  details: () => [...termsAndConditionsQueryKeys.all, 'detail'] as const,
  detail: (brand: TermsAndConditionsBrand, slug: string, locale: string) =>
    [...termsAndConditionsQueryKeys.details(), brand, slug, locale] as const,
};
